<section *ngIf="isLoading && !isLoaded">
  <nz-skeleton [nzActive]="true"
               [nzLoading]="isLoading"
               [nzTitle]="false"
               [nzParagraph]="{ rows: 2 }">
  </nz-skeleton>
</section>
<rappider-title-toolbar *ngIf="!isModalMode && (!isLoading || isLoaded)"
                        [mainTitle]="mainTitle"
                        [options]="title"
                        [displayToolbar]="displayToolbar"
                        [displayToolbarBackButton]="displayToolbarBackButton">
</rappider-title-toolbar>

<section>
  <rappider-spin [spinning]="!projectModelId">
    <rappider-crud-view-edit-form [config]="PROJECT_MODEL_DATA_FIELD_CREATE_CONFIG"
                                  [data]="PROJECT_MODEL_FIELD_DEFAULT_DATA"
                                  [submitButtonLoading]="isFormLoading"
                                  (fieldValueChange)="onDataFieldValueChange($event)"
                                  (formSubmit)="onFormSubmit($event)"></rappider-crud-view-edit-form>
  </rappider-spin>
</section>
